import Enum from '/@/modules/core/app/helpers/Enum';
import Lang from '/@/modules/core/app/services/Lang';

export class LifeInsuranceType extends Enum {
  static PERMANENT = {
    key: 'permanent',
    get value() {
      return Lang.t('asset.permanent');
    }
  };

  static TERM = {
    key: 'term',
    get value() {
      return Lang.t('asset.term');
    }
  };
}
